import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSquareCheckRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M24 4.8c1.766 0 3.2 1.435 3.2 3.2v16c0 1.765-1.434 3.2-3.2 3.2H8A3.203 3.203 0 0 1 4.8 24V8c0-1.765 1.436-3.2 3.2-3.2zM8 7.2c-.44 0-.8.36-.8.8v16c0 .44.36.8.8.8h16c.44 0 .8-.36.8-.8V8c0-.44-.36-.8-.8-.8zm11.536 4.495a1.2 1.2 0 0 1 1.94 1.41l-6.105 8.4a1.18 1.18 0 0 1-.875.49c-.35.025-.695-.1-.94-.345l-2.795-2.795a1.2 1.2 0 0 1 1.695-1.695l1.8 1.8 5.28-7.26z",
		fill: "currentColor"
	})
});
export default SvgSquareCheckRegularIcon;
